module.exports = __webpack_public_path__ + "static/example_week_columns-7d2c98903985a5c84b969da462e80df7.png";